var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcHelpCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15.19 10.364c0 2.127-2.7 3.109-3.026 3.19-.082.082-.164.082-.246.082a.786.786 0 01-.736-.572c-.164-.41.082-.9.49-1.064.492-.164 1.883-.818 1.883-1.718 0-.737-.41-1.31-1.064-1.555-.818-.327-1.8.164-2.127.982-.164.41-.655.655-1.064.491-.41 0-.573-.49-.49-.9a3.185 3.185 0 014.172-1.964 3.168 3.168 0 012.209 3.028zM21 12c0 4.99-4.01 9-9 9s-9-4.01-9-9 4.01-9 9-9 9 4.01 9 9zm-1.636 0A7.333 7.333 0 0012 4.636 7.333 7.333 0 004.636 12 7.333 7.333 0 0012 19.364 7.333 7.333 0 0019.364 12zm-6.791 3.518s-.082-.082-.164-.082-.082-.081-.164-.081c-.081 0-.081 0-.163-.082-.164 0-.327 0-.491.082-.082 0-.164.081-.246.163-.081.082-.163.164-.163.246 0 .081-.082.163-.082.327 0 .245.082.409.245.573a.743.743 0 00.573.245c.246 0 .41-.082.573-.245a.743.743 0 00.245-.573c0-.082 0-.246-.081-.327.081-.082 0-.164-.082-.246z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHelpCircle);
export default __webpack_public_path__ + "static/media/ic-help-circle.1d82c94a3e340b1b74550aa7b9f1271b.svg";
export { ForwardRef as ReactComponent };